import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import styles from '../styles.module.scss';

interface Props {
  isSoldout?: boolean;
  isComingSoon?: boolean;
  item: CollectionListItem;
  clickCallback: (_callback: () => void, id?: number) => void;
}

export default function BenefitCard({
  isSoldout,
  isComingSoon,
  item,
  clickCallback,
}: Props) {
  const navigator = useNavigate();
  const location = useLocation();
  return (
    <div
      className={styles.benefitCardWrapper}
      onClick={($event: React.MouseEvent<HTMLDivElement>) => {
        $event.preventDefault();
        console.log(123123);
        return clickCallback(() => {
          navigator(`/benefit/${item.id}`, {
            state: {
              benefit: item,
              prev: location.pathname.replace('/', ''),
              postPrev: location.state?.prev,
            },
          });
        }, item.id);
      }}
      style={{background: `url('${item.imageUrl}') no-repeat center / cover`}}>
      {item.badgeTxt && (
        <div
          className={styles.benefit}
          style={{display: isComingSoon ? 'none' : 'flex'}}>
          {item.badgeTxt}
        </div>
      )}

      <div
        className={styles.benefitDownload}
        style={{display: isComingSoon ? 'none' : 'flex'}}>
        <div className={styles.txt}>{item.title}</div>
        <span className={styles.downloadIcon}></span>
      </div>
      <div
        className={styles.benefitSoldOutWrapper}
        style={{display: isSoldout ? 'flex' : 'none'}}>
        <div className={styles.soldout}>소진</div>
      </div>
      <div
        className={styles.benefitComingSoon}
        style={{display: isComingSoon ? 'flex' : 'none', cursor: 'default'}}>
        <div className={styles.comingSoon}>
          COMING <br /> SOON
        </div>
      </div>
    </div>
  );
}
